import React from 'react'
import { Badge } from 'components/ui'
import { getCompanyStatusDisplay } from 'utils/companySubscriptionStatus'

const CompanyStatusBadge = ({ status, className = '' }) => {
    const display = getCompanyStatusDisplay(status)

    return (
        <div className={`flex items-center ${className}`}>
            <Badge
                className="w-2 h-2 rounded-full mr-2"
                style={{ backgroundColor: display.dotColor }}
            />
            <span className="font-medium capitalize" style={{ color: display.textColor }}>
                {display.label}
            </span>
        </div>
    )
}

export default CompanyStatusBadge
